// TODO: remove after testing is complete

/**
 * Pass query params to debug flat fee feature
 *
 * useFlatFeeMockData
 *  Uses real data accept for the listing details product data
 *  That will get appended to the real response data
 *  Also by passes isPaymentValid check in edit listing page
 *
 * useFallbackMockData
 *  In the event of a failed endpoint request uses all mock data
 *
 * mock data uses data from app/shared/containers/__mocks__/properties/propertyDetailsData
    products: [
        {
            productType: 1,
            paymentValidDuration: 'week',
            price: '$9.99',
            isEligibleForLeadGuarantee: true,
        },
        {
            productType: 2,
            paymentValidDuration: '90 days',
            price: '$30',
            isEligibleForLeadGuarantee: false,
        },
    ],
 *
 * ex: ?useFlatFeeMockData=true&useFallbackMockData=true
 */


import promise from 'promise';

import ZRMUtils from '@zg-rentals/zrm-utils-js/lib/utils';

// actions
import ModalActions from 'app/shared/actions/ModalActions';

// models
import CurrentProperty from 'app/shared/model/CurrentProperty';
import Unit from 'app/shared/model/Unit';
import Tour from 'app/shared/model/Tour';

// Lodash

// service
import appLogger from 'app/shared/loggers/appLogger';

// utils
import analyticsUtils from 'app/client/utils/analyticsUtils';
import api from 'app/shared/utils/api';
import postingUtils from 'app/shared/utils/postingUtils';

// constants
import AnalyticsConstants from 'app/shared/constants/AnalyticsConstants';
import StringConstants from 'app/shared/constants/StringConstants';

// TODO: remove after testing is complete
import { mockPropertyDetailsWithMetroidProductList }
    from 'app/shared/containers/__mocks__/properties/propertyDetailsData';

import PropertiesActions from './PropertiesActions';

const isString = require('lodash/isString');

const ERROR = {
    CONNECTION_ABORTED: 'Connection aborted',
    FILE_SIZE_EXCEEDS_MAX: 'file size exceeds maximum',
    UPLOAD_PHOTO_ERROR: 'Error when uploading photo',
};

/*
 * formatMaxFileSizeMsg
 * @param origMsg
 *
 * @origMsg format must be [message] : [filesize_number]
 */
function formatMaxFileSizeMsg(origMsg) {
    const msgArr = origMsg.split(':');
    let msg = msgArr[0];
    const value = msgArr[1].trim() / 1024 / 1024 || 0; // convert to mb
    msg = `${msg}: ${value}MB`;

    return msg;
}

const PostingActions = {
    apartment: {
        amenity: {
            create(propertyAmenity) {
                return dispatch => dispatch(api.users.properties.apartmentAmenities.create(propertyAmenity))
                    .then(result => result)
                    .catch(err => promise.reject(err.message));
            },
            delete(amenityId) {
                return dispatch => dispatch(api.users.properties.apartmentAmenities.delete(amenityId))
                    .then(result => result)
                    .catch(err => promise.reject(err.message));
            },
        },
    },
    floorplan: {
        amenity: {
            create(unitAmenity) {
                return dispatch => dispatch(api.users.properties.unitAmenities.create(unitAmenity))
                    .then((result) => {
                        const { error: errorRMWModel, success } = result;

                        if (success === false) {
                            return promise.reject(errorRMWModel);
                        }

                        return result;
                    })
                    .catch((errorRMWModel) => {
                        // dispatch
                        appLogger.logError({
                            message: errorRMWModel.message,
                            context: 'PostingActions.floorplan.amenity.create',
                        });

                        return promise.reject(errorRMWModel);
                    });
            },
            delete(amenityId) {
                return dispatch => dispatch(api.users.properties.unitAmenities.delete(amenityId))
                    .then(result => result)
                    .catch(err => promise.reject(err.message));
            },
        },
        layout: {
            delete(floorPlanId) {
                return dispatch => dispatch(api.users.properties.floorPlans.layouts.delete(floorPlanId))
                    .catch(err => promise.reject(err.message));
            },
            upload(formData) {
                return dispatch => dispatch(api.users.properties.floorPlans.layouts.upload(formData))
                    .then((result) => {
                        const { error: errorRMWModel, success } = result;

                        if (success === false) {
                            return promise.reject(errorRMWModel);
                        }
                        if (result.hasOwnProperty('code') && result.code === 'ECONNABORTED') {
                            // connection aborted
                            errorRMWModel.message = ERROR.CONNECTION_ABORTED;

                            return promise.reject(errorRMWModel);
                        }

                        dispatch(analyticsUtils.track.GAEventV2(
                            AnalyticsConstants.GA_EVENTS.FLOORPLAN_LAYOUT_PHOTO_UPLOAD_SUCCESS
                        ));

                        return result.response;
                    })
                    .catch((errorRMWModel) => {
                        dispatch(analyticsUtils.track.GAEventV2(
                            AnalyticsConstants.GA_EVENTS.FLOORPLAN_LAYOUT_PHOTO_UPLOAD_ERROR
                        ));

                        const msg = errorRMWModel.message;

                        // is filesize error
                        if (errorRMWModel.message.toLowerCase().indexOf(ERROR.FILE_SIZE_EXCEEDS_MAX) > -1) {
                            errorRMWModel.message = formatMaxFileSizeMsg(errorRMWModel.message);
                        }

                        errorRMWModel.message = msg;

                        // do not dispatch via NewRelicService. the components will have better context

                        return promise.reject(errorRMWModel);
                    });
            },
        },
        photo: {
            caption(photoId, caption) {
                const photoObj = {
                    photoId,
                    caption,
                };

                return dispatch => dispatch(api.users.properties.floorPlans.photos.caption(photoObj))
                    .catch(err => promise.reject(err.message));
            },
            delete(photoId) {
                return dispatch => dispatch(api.users.properties.floorPlans.photos.delete(photoId))
                    .catch(err => promise.reject(err.message));
            },
            rotate(photoId, clockwise = true) {
                return dispatch => dispatch(api.users.properties.floorPlans.photos.rotate(photoId, clockwise))
                    .catch(err => promise.reject(err.message));
            },
            upload(formData) {
                return dispatch => dispatch(api.users.properties.floorPlans.photos.upload(formData))
                    .then((result) => {
                        const { error: errorRMWModel, success } = result;

                        if (success === false) {
                            return promise.reject(errorRMWModel);
                        }
                        if (result.hasOwnProperty('code') && result.code === 'ECONNABORTED') {
                            // connection aborted
                            errorRMWModel.message = ERROR.CONNECTION_ABORTED;

                            return promise.reject(errorRMWModel);
                        }

                        dispatch(analyticsUtils.track.GAEventV2(
                            AnalyticsConstants.GA_EVENTS.FLOORPLAN_PHOTO_UPLOAD_SUCCESS
                        ));

                        return result.response;
                    })
                    .catch((errorRMWModel) => {
                        dispatch(analyticsUtils.track.GAEventV2(
                            AnalyticsConstants.GA_EVENTS.FLOORPLAN_PHOTO_UPLOAD_ERROR
                        ));

                        // is filesize error
                        if (errorRMWModel.message.toLowerCase().indexOf(ERROR.FILE_SIZE_EXCEEDS_MAX) > -1) {
                            errorRMWModel.message = formatMaxFileSizeMsg(errorRMWModel.message);
                        }

                        // do not dispatch via NewRelicService. the components will have better context

                        return promise.reject(errorRMWModel);
                    });
            },
        },
        get(floorplanId) {
            return dispatch => dispatch(api.users.properties.floorPlans.get(floorplanId))
                .then(result => result.response)
                .catch(err => promise.reject(err.message));
        },
        edit(formData) {
            return (dispatch) => {
                const mapFormFieldNameToApiFieldName =
                    postingUtils.mapFormDataToApi(`floorplans.${formData.fieldName}`);

                const dataToSave = {
                    fieldName: mapFormFieldNameToApiFieldName,
                    [mapFormFieldNameToApiFieldName]: formData.value,
                    floorPlanId: formData.floorPlanId,
                };

                return dispatch(api.users.properties.floorPlans.edit(dataToSave))
                    .then((result) => {
                        if (result.success === false) {
                            return promise.reject(result.error);
                        }

                        return result.response;
                    })
                    .catch(err => promise.reject(err.message));
            };
        },
    },
    property: {
        amenity: {
            create(propertyAmenity, componentGroupName = '') {
                return dispatch => dispatch(api.users.properties.amenities.create(propertyAmenity))
                    .then((result) => {
                        if (result.success === false) {
                            return promise.reject(result.error);
                        }

                        return result;
                    })
                    .catch((errorRMWModel) => {
                        // if group name
                        if (componentGroupName !== '') {
                            // update GA action with component group name + Error
                            AnalyticsConstants.GA_EVENTS.LISTING_INPUT_ERROR.action = `${componentGroupName}Error`;
                        }

                        dispatch(analyticsUtils.track.GAEventV2(
                            AnalyticsConstants.GA_EVENTS.LISTING_INPUT_ERROR,
                        ));

                        // dispatch
                        appLogger.logError({
                            message: errorRMWModel.message,
                            context: 'PostingActions.property.amenity.create',
                        });

                        return promise.reject(errorRMWModel);
                    });
            },
            delete(amenityId) {
                return dispatch => dispatch(api.users.properties.amenities.delete(amenityId))
                    .then(result => result)
                    .catch(err => promise.reject(err.message));
            },
            update(data) {
                return dispatch => dispatch(api.users.properties.amenities.update(data))
                    .then((result) => {
                        if (result.success === false) {
                            return promise.reject(result.error);
                        }

                        return result;
                    })
                    .catch((errorRMWModel) => {
                        dispatch(analyticsUtils.track.GAEventV2(
                            AnalyticsConstants.GA_EVENTS.LISTING_INPUT_ERROR,
                        ));

                        // dispatch
                        appLogger.logError({
                            message: errorRMWModel.message,
                            context: 'PostingActions.property.amenity.update',
                        });

                        return promise.reject(errorRMWModel);
                    });
            },
        },
        photo: {
            caption(photoId, caption) {
                const photoObj = {
                    photoId,
                    caption,
                };

                return dispatch => dispatch(api.users.properties.photos.caption(photoObj))
                    .then((result) => {
                        const { error: errorRMWModel, success } = result;

                        if (success === false) {
                            return promise.reject(errorRMWModel);
                        }

                        return result.response;
                    })
                    .catch(errorRMWModel => promise.reject(errorRMWModel));
            },
            delete(photoId) {
                return dispatch => dispatch(api.users.properties.photos.delete(photoId))
                    .then((result) => {
                        const { error: errorRMWModel, success } = result;

                        if (success === false) {
                            return promise.reject(errorRMWModel);
                        }

                        return result.response;
                    })
                    .catch(errorRMWModel => promise.reject(errorRMWModel));
            },
            sort(dataToSave) {
                return (dispatch) => {
                    const photoSortObj = {
                        propertyId: dataToSave.propertyId,
                        photosArray: dataToSave.photosArray,
                    };

                    return dispatch(api.users.properties.photos.sort(photoSortObj))
                        .then((result) => {
                            const { error: errorRMWModel, success } = result;

                            if (success === false) {
                                return promise.reject(errorRMWModel);
                            }

                            return result.response;
                        })
                        .catch((errorRMWModel) => {
                            // dispatch
                            appLogger.logError({
                                message: errorRMWModel.message,
                                context: 'PostingActions.property.photo.sort',
                            });

                            return promise.reject(errorRMWModel);
                        });
                };
            },
            upload(formData) {
                return dispatch => dispatch(api.users.properties.photos.upload(formData))
                    .then((result) => {
                        const { error: errorRMWModel, success } = result;

                        if (success === false) {
                            return promise.reject(errorRMWModel);
                        }
                        if (result.hasOwnProperty('code') && result.code === 'ECONNABORTED') {
                            // connection aborted
                            return promise.reject({ message: ERROR.CONNECTION_ABORTED });
                        }

                        dispatch(analyticsUtils.track.GAEventV2(
                            AnalyticsConstants.GA_EVENTS.PHOTO_UPLOAD_SUCCESS
                        ));

                        return result.response;
                    })
                    .catch((errorRMWModel) => {
                        dispatch(analyticsUtils.track.GAEventV2(AnalyticsConstants.GA_EVENTS.PHOTO_UPLOAD_ERROR));

                        let errorMessage;
                        if (errorRMWModel) {
                            errorMessage = errorRMWModel.message ||
                                    (isString(errorRMWModel) ? errorRMWModel : ERROR.UPLOAD_PHOTO_ERROR);
                        } else {
                            errorMessage = ERROR.UPLOAD_PHOTO_ERROR;
                        }

                        // is filesize error
                        if (errorMessage.toLowerCase().indexOf(ERROR.FILE_SIZE_EXCEEDS_MAX) > -1) {
                            errorMessage = formatMaxFileSizeMsg(errorMessage);
                        }

                        return promise.reject(errorMessage);
                    });
            },
            rotate(photoId, clockwise) {
                return dispatch => dispatch(api.users.properties.photos.rotate(photoId, clockwise))
                    .then((result) => {
                        const { error: errorRMWModel, success } = result;

                        if (success === false) {
                            return promise.reject(errorRMWModel);
                        }
                        return result;
                    })
                    .catch((errorRMWModel) => {
                        appLogger.logError({
                            message: errorRMWModel.message,
                            context: 'PostingActions.property.photo.rotate',
                        });

                        return promise.reject(errorRMWModel);
                    });
            },

            replace(params) {
                return dispatch => dispatch(api.users.properties.photos.replace(params))
                    .then((result) => {
                        if (result.success === false) {
                            return promise.reject(result.error);
                        }
                        return result.response;
                    })
                    .catch((err) => {
                        err = {
                            // sometimes error response does not have message property
                            message: err.message || err,
                        };

                        return promise.reject(err.message);
                    });
            },
        },
        activate(propertyId, extending) {
            const daysToExtend = extending ? 30 : null;

            return dispatch => dispatch(api.users.properties.activate(propertyId, daysToExtend))
                .then((result) => {
                    const { error: errorRMWModel, success } = result;

                    if (success === false) {
                        return promise.reject(errorRMWModel);
                    }
                    return result;
                })
                .catch(errorRMWModel => promise.reject(errorRMWModel));
        },
        deactivate(propertyId, reason = null) {
            return dispatch => dispatch(api.users.properties.deactivate(propertyId, reason))
                .then((result) => {
                    if (result.success === false) {
                        return promise.reject(result.error);
                    }
                    return result;
                })
                .catch((errorRMWModel) => {
                    appLogger.logError({
                        message: errorRMWModel.message,
                        context: 'PostingActions.property.deactivate',
                    });

                    return promise.reject(errorRMWModel);
                });
        },
        create(formData) {
            return (dispatch) => {
                const dataForApi = postingUtils.transformPropertyListingTypeForApi(formData);

                return dispatch(api.users.properties.create(dataForApi))
                    .then((result) => {
                        const { error: errorRMWModel, success } = result;

                        if (success === false) {
                            return promise.reject(errorRMWModel);
                        }
                        const propertyId = result.response.propertyId;

                        return dispatch(PostingActions.property.getDetails(propertyId));
                    })
                    .catch((errorRMWModel) => {
                        // dispatch
                        appLogger.logError({
                            message: errorRMWModel.message,
                            context: 'PostingActions.property.create',
                        });

                        return promise.reject(errorRMWModel);
                    });
            };
        },
        delete(propertyId, reason) {
            return dispatch => dispatch(api.users.properties.delete(propertyId, reason))
                .then(result => result)
                .catch(err => promise.reject(err.message));
        },
        // archive property
        archive(propertyId) {
            return dispatch => dispatch(api.users.properties.archive(propertyId))
                .then((result) => {
                    if (result.success) {
                        // if archive is called -> safely say that property could be unarchived.
                        // set the current property in store with canBeArchived as false
                        dispatch(PropertiesActions.updateCurrentProperty({ canBeArchived: false }));
                    }
                    return result;
                })
                .catch(err => promise.reject(err.message));
        },
        // unarchive property
        unArchive(propertyId) {
            return dispatch => dispatch(api.users.properties.unArchive(propertyId))
                .then((result) => {
                    if (result.success) {
                        // if unarchive is called -> safely say that property was able to be archived.
                        // set the current property in store with canBeArchived as true
                        dispatch(PropertiesActions.updateCurrentProperty({ canBeArchived: true }));
                    }
                    return result;
                })
                .catch(err => promise.reject(err.message));
        },
        autoBill(propertyId) {
            return dispatch => dispatch(api.users.properties.autoBill(propertyId))
                .then((response) => {
                    if (response.success) {
                        dispatch(ModalActions.updateModal({
                            isDeactivationScheduled: true,
                        }));
                        dispatch(PropertiesActions.updateCurrentProperty({ autoBill: false }));
                    } else {
                        dispatch(ModalActions.updateModal({
                            header: 'Error',
                            errorMessage: response.error.message,
                        }));
                    }
                    return response;
                })
                .catch(err => promise.reject(err.message));
        },
        getLeasesSummary(propertyId) {
            return dispatch => dispatch(api.users.properties.getLeasesSummary(propertyId))
                .then((response) => {
                    if (response.success && response.response) {
                        return response.response;
                    }
                    return promise.reject(response.error);
                })
                .catch((errorRMWModel) => {
                    const errorToReturn = { ...errorRMWModel };
                    appLogger.logError({
                        message: errorRMWModel.message,
                        context: 'PostingActions.getLeasesSummary',
                    });

                    if (errorRMWModel.code === StringConstants.MISSING_PARAM) {
                        delete errorToReturn.message;
                    }

                    return promise.reject(errorToReturn);
                });
        },
        getPaymentsSummary(propertyId) {
            return dispatch => dispatch(api.users.properties.getPaymentsSummary(propertyId))
                .then((response) => {
                    if (response.success && response.response) {
                        return response.response;
                    }
                    return promise.reject(response.error);
                })
                .catch((errorRMWModel) => {
                    const errorToReturn = { ...errorRMWModel };
                    appLogger.logError({
                        message: errorRMWModel.message,
                        context: 'PostingActions.getPaymentsSummary',
                    });

                    if (errorToReturn.code === StringConstants.MISSING_PARAM) {
                        delete errorToReturn.message;
                    }
                    return promise.reject(errorToReturn);
                });
        },
        markAcknowledgedLandlordMessage(actionId) {
            return dispatch => dispatch(api.users.properties.markAcknowledgedLandlordMessage(actionId))
                .then((response) => {
                    if (response.success && response.response) {
                        return response.response;
                    }
                    return promise.reject(response.error);
                })
                .catch((errorRMWModel) => {
                    appLogger.logError({
                        message: errorRMWModel.message,
                        context: 'PostingActions.markAcknowledgedLandlordMessage',
                    });

                    return promise.reject(errorRMWModel);
                });
        },
        getListingSummary(listingAlias) {
            return dispatch => dispatch(api.users.properties.getListingSummary(listingAlias))
                .then((result) => {
                    const { error: errorRMWModel, success, response } = result;

                    if (success && response) {
                        return response;
                    }
                    return promise.reject(errorRMWModel);
                })
                .catch((errorRMWModel) => {
                    const errorToReturn = { ...errorRMWModel };
                    appLogger.logError({
                        message: errorRMWModel.message,
                        context: 'PostingActions.getListingSummary',
                    });

                    if (errorRMWModel.code === StringConstants.MISSING_PARAM) {
                        errorToReturn.message = 'An error occurred.';
                    }
                    return promise.reject(errorToReturn);
                });
        },
        // add boolean for restrictions
        getDetails(propertyId) {
            return this.getDetailsInternal(api.users.properties.getDetails(propertyId));
        },
        getDetailsForEncodedAlias(encodedAlias) {
            return this.getDetailsInternal(api.users.properties.getDetailsForEncodedAlias(encodedAlias));
        },
        getDetailsInternal(dispatchedApi) {
            // TODO: remove after testing is complete
            // check query param to apply mock data
            const queryParamObj = ZRMUtils.queryUtils.parse(window.location.search);

            let {
                useFlatFeeMockData,
                useFallbackMockData,
            } = queryParamObj;

            // uses real data accept for the listing details product data
            useFlatFeeMockData = useFlatFeeMockData !== undefined && useFlatFeeMockData === 'true';

            // uses all mock data
            useFallbackMockData = useFallbackMockData !== undefined && useFallbackMockData === 'true';

            return dispatch => dispatch(dispatchedApi)
                .then((result) => {
                    // TODO: remove after testing is complete
                    let { error: errorRMWModel, success, response } = result;
                    let dataForForm = {};

                    // the request has been erroring out a lot lately
                    if (success === false && useFallbackMockData === true) {
                        errorRMWModel = {
                            ...errorRMWModel,
                            message: 'could not load the property details',
                        };

                        console.error('ERROR: ', errorRMWModel.message);
                        console.warn('[WARN]: Using mock property details data >>');
                        success = true;
                        response = mockPropertyDetailsWithMetroidProductList;
                    }

                    if (success) {
                        // TODO: add paidInclusion.products to transform data posting utils
                        dataForForm = postingUtils.transformDatafromApi(response);

                        // TODO: remove after testing is complete
                        if (useFlatFeeMockData) {
                            dataForForm.paidInclusion = {
                                ...dataForForm.paidInclusion,
                                ...mockPropertyDetailsWithMetroidProductList.paidInclusion,
                            };
                        }

                        const mergedListingAndTransformedData = {
                            ...dataForForm,
                        };

                        // isConnectedExperience gets set with the default value in data model
                        const currentPropertyModel = CurrentProperty(mergedListingAndTransformedData);

                        // FIND: update listing isConnectedExperience
                        dispatch(PropertiesActions.updateCurrentProperty(currentPropertyModel));

                        dataForForm.propertyId = dataForForm.listingId;
                    } else {
                        // error
                        return promise.reject(errorRMWModel);
                    }

                    return dataForForm;
                })
                .catch((errorRMWModel) => {
                    // dispatch
                    appLogger.logError({
                        message: errorRMWModel.message,
                        context: 'PostingActions.getDetails',
                    });

                    return promise.reject(errorRMWModel);
                });
        },
        getStatus(propertyId) {
            return dispatch => dispatch(api.users.properties.getStatus(propertyId))
                .then((result) => {
                    const { error: errorRMWModel, success, response } = result;

                    if (success === false) {
                        return promise.reject(errorRMWModel);
                    }

                    // sync with current property
                    const {
                        expirationDate,
                        dateLastActivated,
                        numLeadsSinceLastActivated,
                    } = response;

                    dispatch(PropertiesActions.updateCurrentProperty({
                        dateLastActivated,
                        expirationDate,
                        numLeadsSinceLastActivated,
                    }));

                    return response;
                })
                .catch((errorRMWModel) => {
                    // dispatch
                    appLogger.logError({
                        message: errorRMWModel.message,
                        context: 'PostingActions.getStatus',
                    });

                    return promise.reject(errorRMWModel);
                });
        },
        edit(formData, { componentGroupName = '', preserveFieldName = false } = {}) {
            return (dispatch) => {
                let dataToSave;

                if (preserveFieldName === false) {
                    const mapFormFieldNameToApiFieldName = postingUtils.mapFormDataToApi(formData.fieldName);

                    if (mapFormFieldNameToApiFieldName === undefined) {
                        console.error('ERROR: field is not found in mapFormDataToApi', formData.fieldName);

                        return promise.reject();
                    }

                    dataToSave = {
                        fieldName: mapFormFieldNameToApiFieldName,
                        [mapFormFieldNameToApiFieldName]: formData.value,
                        propertyId: formData.propertyId,
                    };
                } else {
                    const { fieldName } = formData;
                    dataToSave = {
                        fieldName,
                        [fieldName]: formData.value,
                        propertyId: formData.propertyId,
                    };
                }


                // Handle an issue on the API side when an empty value is provided.
                if (formData.fieldName === 'contactEmail' && formData.value === '') {
                    return promise.reject('Please enter a valid email address.');
                }

                return dispatch(api.users.properties.edit(dataToSave))
                    .then((result) => {
                        if (result.success === false) {
                            return promise.reject(result.error);
                        }

                        return result;
                    })
                    .catch((err) => {
                        // if group name
                        if (componentGroupName !== '') {
                            // update GA action with component group name + Error
                            AnalyticsConstants.GA_EVENTS.LISTING_INPUT_ERROR.action = `${componentGroupName}Error`;
                        }

                        dispatch(analyticsUtils.track.GAEventV2(AnalyticsConstants.GA_EVENTS.LISTING_INPUT_ERROR));

                        return promise.reject(err.message);
                    });
            };
        },
        pets(dataToSave) {
            return dispatch => dispatch(api.users.properties.pets(dataToSave))
                .then(result => result)
                .catch(err => promise.reject(err.message));
        },
        createNewFloorplan(propertyId) {
            return dispatch => dispatch(api.users.properties.floorPlans.create(propertyId))
                .then(result => result.response)
                .catch(err => promise.reject(err.message));
        },
        unit: {
            create(floorPlanId, params) {
                const mappedParams = Object.keys(params).reduce((acc, key) => {
                    const backendKey = postingUtils.mapFormDataToApi(`floorplans.${key}`);
                    acc[backendKey] = params[key];
                    return acc;
                }, {});
                return dispatch => dispatch(api.users.properties.floorPlans.units.createV2(floorPlanId, mappedParams))
                    .then((result) => {
                        if (result.error) {
                            return promise.reject(result);
                        }
                        return new Unit(result.response);
                    });
            },
            edit(unitId, params) {
                const mappedParams = Object.keys(params).reduce((acc, key) => {
                    const backendKey = postingUtils.mapFormDataToApi(`floorplans.${key}`);
                    acc[backendKey] = params[key];
                    return acc;
                }, {});
                return dispatch => dispatch(api.users.properties.floorPlans.units.edit(unitId, mappedParams))
                    .then((result) => {
                        if (result.error) {
                            return promise.reject(result);
                        }
                        return result;
                    });
            },
            get(unitId) {
                return dispatch => dispatch(api.users.properties.floorPlans.get(unitId))
                    .then(result => new Unit(result.response))
                    .catch(err => promise.reject(err.message));
            },
        },
        vrModel: {
            getAll(encodedAlias) {
                return dispatch => dispatch(api.users.properties.vrModel.getAll(encodedAlias))
                    .then((result) => {
                        const { error: errorRMWModel, success } = result;
                        if (success === false) {
                            return promise.reject(errorRMWModel);
                        }

                        return result.response.vrModels.map(vrModel => new Tour(vrModel));
                    })
                    .catch(err => promise.reject(err.message));
            },
            associateModel(vrModelId, encodedAlias, encodedFloorplanKey, shouldAssociate) {
                return dispatch => dispatch(api.users.properties.vrModel.associateModel(vrModelId, encodedAlias,
                    encodedFloorplanKey, shouldAssociate))
                    .then((result) => {
                        const { error: errorRMWModel, success } = result;
                        if (success === false) {
                            return promise.reject(errorRMWModel);
                        }

                        return new Tour(result.response);
                    })
                    .catch(err => promise.reject(err.message));
            },
            associateListing(vrModelId, encodedAlias, shouldAssociate) {
                return dispatch => dispatch(api.users.properties.vrModel.associateListing(vrModelId, encodedAlias,
                    shouldAssociate))
                    .then((result) => {
                        const { error: errorRMWModel, success } = result;
                        if (success === false) {
                            return promise.reject(errorRMWModel);
                        }

                        return new Tour(result.response);
                    })
                    .catch(err => promise.reject(err.message));
            },
            publishModel(encodedAlias, vrModelId, encodedFloorplanKey, shouldPublish) {
                return dispatch => dispatch(api.users.properties.vrModel.publishModel(encodedAlias, vrModelId,
                    encodedFloorplanKey, shouldPublish))
                    .then((result) => {
                        const { error: errorRMWModel, success } = result;
                        if (success === false) {
                            return promise.reject(errorRMWModel);
                        }

                        return new Tour(result.response);
                    })
                    .catch(err => promise.reject(err.message));
            },
            publishListing(vrModelId, encodedAlias, shouldPublish) {
                return dispatch => dispatch(api.users.properties.vrModel.publishListing(vrModelId, encodedAlias,
                    shouldPublish))
                    .then((result) => {
                        const { error: errorRMWModel, success } = result;
                        if (success === false) {
                            return promise.reject(errorRMWModel);
                        }

                        return new Tour(result.response);
                    })
                    .catch(err => promise.reject(err.message));
            },
        },
        createNewUnit(floorPlanId) {
            return dispatch => dispatch(api.users.properties.floorPlans.units.create(floorPlanId))
                .then(result => result.response)
                .catch(err => promise.reject(err.message));
        },
        removeFloorplan(floorplanId) {
            return dispatch => dispatch(api.users.properties.floorPlans.delete(floorplanId))
                .then((result) => {
                    const { error: errorRMWModel, success } = result;

                    if (success === false) {
                        return promise.reject(errorRMWModel);
                    }

                    return result.response;
                })
                .catch((errorRMWModel) => {
                    // dispatch
                    appLogger.logError({
                        message: errorRMWModel.message,
                        context: 'PostingActions.property.removeFloorplan',
                    });

                    return promise.reject(errorRMWModel);
                });
        },
        syndication(propertyId) {
            return dispatch => dispatch(api.users.properties.syndication(propertyId))
                .then((result) => {
                    if (result.success === false) {
                        return promise.reject(result.error);
                    }

                    return result.response;
                })
                .catch((err) => {
                    const msg = err.message;
                    return promise.reject(msg);
                });
        },
        uploadLogo(formData) {
            return dispatch => dispatch(api.users.properties.logos.upload(formData))
                .then((result) => {
                    if (result.success === false) {
                        return promise.reject(result.error);
                    }
                    if (result.hasOwnProperty('code') && result.code === 'ECONNABORTED') {
                        // connection aborted
                        return promise.reject({ message: ERROR.CONNECTION_ABORTED });
                    }

                    dispatch(analyticsUtils.track.GAEventV2(AnalyticsConstants.GA_EVENTS.LOGO_UPLOAD_SUCCESS));

                    return result.response;
                })
                .catch((err) => {
                    dispatch(analyticsUtils.track.GAEventV2(AnalyticsConstants.GA_EVENTS.LOGO_UPLOAD_ERROR));

                    let msg = err.message;

                    // is filesize error
                    if (msg.toLowerCase().indexOf(ERROR.FILE_SIZE_EXCEEDS_MAX) > -1) {
                        msg = formatMaxFileSizeMsg(err.message);
                    }

                    return promise.reject(msg);
                });
        },
        removeLogo(propertyId) {
            return dispatch => dispatch(api.users.properties.logos.delete(propertyId))
                .catch(err => promise.reject(err.message));
        },
        confirmVerification(contactData) {
            return dispatch => dispatch(api.users.contacts.verifier.confirm(contactData))
                .then(result => result)
                .catch(err => promise.reject(err.message));
        },
        requestVerification(contactData) {
            return dispatch => dispatch(api.users.contacts.verifier.send(contactData))
                .then(result => result)
                .catch(err => promise.reject(err.message));
        },
    },
};

export default PostingActions;
